import React from 'react';
import { Box } from '@mui/material';
import { useAuth } from '../context/AuthContext';
import { SidebarProvider } from '../context/SidebarContext';
import ModernHeader from './ModernHeader';
import PrincipalSidebar from './PrincipalSidebar';
import MobileBottomNav from './MobileBottomNav';
import Footer from './Footer';
import ImpersonationBanner from './ImpersonationBanner';
import PlanStatusBanner from './PlanStatusBanner';
import { BOTTOM_NAV_ROLES } from './MobileBottomNav';

const SIDEBAR_ROLES = ['principal', 'school_admin'];

// Shared shell for every authenticated page: a full-width sticky header that
// never gets clipped by a scrollbar, because only the content column below
// it scrolls — the header and sidebar sit outside the scrolling region.
const AppLayout = ({ children }) => {
  const { user } = useAuth();
  const hasSidebar = SIDEBAR_ROLES.includes(user?.role);
  const hasBottomNav = BOTTOM_NAV_ROLES.includes(user?.role);

  return (
    <SidebarProvider>
      <Box sx={{ height: '100vh', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
        <ImpersonationBanner />
        <PlanStatusBanner />
        <ModernHeader />
        <Box sx={{ flex: 1, display: 'flex', overflow: 'hidden' }}>
          {hasSidebar && <PrincipalSidebar />}
          <Box sx={{ flex: 1, minWidth: 0, overflowY: 'auto', display: 'flex', flexDirection: 'column', pb: { xs: hasBottomNav ? 8 : 0, md: 0 } }}>
            <Box sx={{ flex: 1 }}>
              {children}
            </Box>
            <Footer />
          </Box>
        </Box>
      </Box>
      {/* Self-hides for roles without a bottom nav (e.g. principal) and on desktop */}
      <MobileBottomNav />
    </SidebarProvider>
  );
};

export default AppLayout;
